<template>
  <input
    class="h-6 w-6 cursor-pointer rounded-md border text-indigo-500 focus:ring"
    :class="
      invalid
        ? `border-2 border-rose-600 text-rose-500 focus:border-rose-500 focus:ring-rose-200`
        : `border-slate-300`
    "
    :style="{
      color: variant ? variant[500] : null,
      '--tw-ring-color': variant ? variant[300] : null,
    }"
    :checked="isChecked"
    :id="id"
    type="checkbox"
    :value="value"
    @change="updateInput"
  />
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    falseValue: {
      default: false,
    },
    id: {
      required: true,
      type: String,
    },
    invalid: {
      required: true,
      type: Boolean,
    },
    label: {
      required: false,
      type: String,
    },
    modelValue: {
      required: true,
    },
    trueValue: {
      default: true,
    },
    value: {
      required: false,
      type: String,
    },
    variant: {
      required: true,
      type: [Object, String],
    },
  },

  setup(props, { emit }) {
    const isChecked = computed(() => {
      if (props.modelValue instanceof Array) {
        return props.modelValue.includes(props.value);
      }
      return props.modelValue === props.trueValue;
    });

    const updateInput = (event) => {
      const isChecked = event.target.checked;
      if (props.modelValue instanceof Array) {
        const newValue = [...props.modelValue];
        if (isChecked) {
          newValue.push(props.value);
        } else {
          newValue.splice(newValue.indexOf(props.value), 1);
        }
        emit("update:modelValue", newValue);
      } else {
        emit(
          "update:modelValue",
          isChecked ? props.trueValue : props.falseValue
        );
      }
    };

    return {
      isChecked,
      updateInput,
    };
  },
};
</script>
